(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/views/terms-integrity.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/views/terms-integrity.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.terms_integrity=_svs.terms_integrity||{};
_svs.terms_integrity.templates=_svs.terms_integrity.templates||{};
svs.terms_integrity.templates.terms_integrity = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"f-content js-react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-terms_integrity-terms_integrity'] = svs.terms_integrity.templates.terms_integrity;
})(svs, Handlebars);


 })(window);